// Link da bio Ela Decora (versão dentro da loja): busca com a assistente e quiz da consultora.
// Textos, intenções e quiz vêm de bio-dados.js (gerado do bio.config.json). Preço, foto e estoque
// vêm ao vivo da própria loja (Storefront API no mesmo domínio, sem token).
(function () {
  'use strict';

  var B = window.__BIO_CFG__ || {};
  var corpo = document.body;
  var $ = function (id) { return document.getElementById(id); };

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var fmt = function (v) {
    var p = Number(v).toFixed(2).split('.');
    return 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  };
  var norm = function (s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); };
  var svg = function (path, tam, sw) {
    return '<svg aria-hidden="true" width="' + tam + '" height="' + tam + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 1.7) +
      '" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
  };
  var tint = function (c) { return (B.cats[c] || B.cats.potes).tint; };
  var fotoHtml = function (p) {
    return p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.alt || p.nome) + '" loading="lazy" decoding="async" width="480" height="480">' : svg(B.ic[p.cat] || B.ic.potes, 38, 1.2);
  };
  var urlProduto = function (handle) { return '/products/' + handle; };
  var destino = function (d) {
    if (!d) return '/';
    if (d.colecao) return '/collections/' + d.colecao;
    if (d.busca) return '/search?type=product&q=' + encodeURIComponent(d.busca);
    return d.url || '/';
  };

  // ===================== Dados ao vivo da loja =====================
  var FRAG = 'fragment P on Product { title handle availableForSale ' +
    'featuredImage { url(transform: {maxWidth: 240, preferredContentType: WEBP}) altText } ' +
    'variants(first: 5) { nodes { id availableForSale price { amount } compareAtPrice { amount } } } }';

  // Primeiro tenta no próprio domínio; se falhar, usa o endereço .myshopify.com da loja (mesma API).
  var API = '/api/2025-07/graphql.json';
  var RESERVA = window.Shopify && Shopify.shop ? 'https://' + Shopify.shop + API : '';
  function chamar(url, corpo) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: corpo })
      .then(function (r) { if (!r.ok) throw new Error('loja ' + r.status); return r.json(); })
      .then(function (j) { if (!j.data) throw new Error('loja sem dados'); return j.data; });
  }
  function gql(query, variables) {
    var corpo = JSON.stringify({ query: query, variables: variables || {} });
    return chamar(API, corpo).catch(function (erro) {
      if (!RESERVA) throw erro;
      return chamar(RESERVA, corpo);
    });
  }

  var porHandle = {};
  Object.keys(B.produtos).forEach(function (id) { porHandle[B.produtos[id].handle] = id; });

  // Junta o dado vivo com o texto curado (nome curto, frase).
  function montar(node) {
    if (!node) return null;
    var vs = (node.variants && node.variants.nodes) || [];
    var v = vs.filter(function (x) { return x.availableForSale; })[0] || vs[0];
    if (!v) return null;
    var id = porHandle[node.handle] || node.handle;
    var curado = B.produtos[id] || {};
    var preco = Number(v.price.amount);
    var de = v.compareAtPrice ? Number(v.compareAtPrice.amount) : 0;
    return {
      id: id, handle: node.handle, nome: curado.nome || node.title, porque: curado.porque || '', cat: curado.cat || 'potes',
      disponivel: !!node.availableForSale && v.availableForSale !== false,
      img: node.featuredImage ? node.featuredImage.url : '', alt: (node.featuredImage && node.featuredImage.altText) || node.title,
      preco: preco, de: de > preco ? de : 0, variante: String(v.id).split('/').pop()
    };
  }

  var guardados = {};
  // Produtos curados por id (do bio-dados.js), em uma chamada só; guarda o que já buscou.
  function porIds(ids) {
    var faltam = ids.filter(function (id) { return !(id in guardados) && B.produtos[id]; });
    if (!faltam.length) return Promise.resolve(ids.map(function (id) { return guardados[id] || null; }));
    var q = FRAG + ' query { ' + faltam.map(function (id, i) { return 'p' + i + ': product(handle: ' + JSON.stringify(B.produtos[id].handle) + ') { ...P }'; }).join(' ') + ' }';
    return gql(q).then(function (data) {
      faltam.forEach(function (id, i) { guardados[id] = montar(data['p' + i]); });
      return ids.map(function (id) { return guardados[id] || null; });
    });
  }
  var soDisponiveis = function (lista) { return lista.filter(function (p) { return p && p.disponivel; }); };

  function daBusca(termo, max) {
    var filtros = [{ available: true }];
    if (max) filtros.push({ price: { max: max } });
    return gql(FRAG + ' query($q: String!, $f: [ProductFilter!]) { search(query: $q, first: 6, types: PRODUCT, productFilters: $f) { nodes { ...P } } }', { q: termo, f: filtros })
      .then(function (d) { return soDisponiveis(d.search.nodes.map(montar)); });
  }
  function daColecao(handle, max) {
    var filtros = [{ available: true }];
    if (max) filtros.push({ price: { max: max } });
    return gql(FRAG + ' query($h: String!, $f: [ProductFilter!]) { collection(handle: $h) { products(first: 6, sortKey: BEST_SELLING, filters: $f) { nodes { ...P } } } }', { h: handle, f: filtros })
      .then(function (d) { return d.collection ? soDisponiveis(d.collection.products.nodes.map(montar)) : []; });
  }
  var semErro = function (p) { return p.catch(function () { return []; }); };

  // ===================== Assistente de busca =====================
  // 1) intenção curada (frase + produtos escolhidos); 2) busca da própria loja; 3) mais procurados.
  function responder(qBruto, filtro) {
    var q = (qBruto || '').trim().slice(0, 80);
    var nq = norm(q);
    var barato = filtro === 'barato';
    var teto = B.precoBarato;
    var ateTeto = 'Até R$ ' + teto;
    var it = B.busca.intencoes.filter(function (i) { return i.chaves.some(function (k) { return nq.indexOf(norm(k)) >= 0; }); })[0];

    if (!it) {
      return semErro(daBusca(q, barato ? teto : 0)).then(function (achados) {
        if (achados.length) {
          return { titulo: 'Achei pra "' + q + '"', intro: barato ? ateTeto + ', esses resolvem bem:' : 'Olha o que eu separei pra você:', itens: achados.slice(0, 3), url: destino({ busca: q }), cta: 'Ver mais no site' };
        }
        return porIds(B.busca.semResultado.produtos).then(function (lista) {
          return { titulo: B.busca.semResultado.titulo, intro: B.busca.semResultado.intro, itens: soDisponiveis(lista).slice(0, 3), url: destino({ busca: q }), cta: 'Buscar "' + q + '" no site' };
        });
      });
    }

    var daFonte = function (max) { return semErro(it.colecao ? daColecao(it.colecao, max || it.precoMax) : daBusca(it.busca, max)); };
    var ids = it.produtos.slice();
    if (it.seEsgotado && ids.indexOf(it.seEsgotado.produto) < 0) ids.push(it.seEsgotado.produto);

    return porIds(ids).then(function (lista) {
      var r = { titulo: it.titulo, intro: it.intro, url: destino(it.destino), cta: it.cta };
      if (it.seEsgotado) {
        var alvo = guardados[it.seEsgotado.produto];
        if (!alvo || !alvo.disponivel) {
          r.intro = it.seEsgotado.intro;
          r.cta = it.seEsgotado.cta || r.cta;
          if (alvo) r.url = urlProduto(alvo.handle);
        }
      }
      var itens = soDisponiveis(it.produtos.map(function (id) { return guardados[id]; })).slice(0, 3);
      var completar = itens.length < 3 ? daFonte(0) : Promise.resolve([]);
      return completar.then(function (extra) {
        extra.forEach(function (p) { if (itens.length < 3 && !itens.some(function (x) { return x.handle === p.handle; })) itens.push(p); });
        if (!barato) { r.itens = itens; return r; }
        return daFonte(teto).then(function (pool) {
          if (pool.length) { r.itens = pool.slice(0, 3); r.intro = ateTeto + ', esses resolvem bem:'; }
          else { r.itens = itens.slice().sort(function (a, b) { return a.preco - b.preco; }); r.intro = ateTeto + ' eu não tenho nessa categoria, mas esses são os mais em conta:'; }
          return r;
        });
      });
    });
  }

  var form = $('busca-form');
  var campo = $('busca-ia');
  var ia = $('ia');
  var iaTitulo = $('t-ia');
  var iaIntro = $('ia-intro');
  var iaItens = $('ia-itens');
  var iaCta = $('ia-cta');
  var busca = { q: '', f: '' };
  var pedido = 0;

  function itemHtml(p) {
    var href = urlProduto(p.handle);
    return '<article class="item">' +
      '<a class="item-foto" href="' + esc(href) + '" aria-label="Ver produto: ' + esc(p.nome) + '" style="background:' + tint(p.cat) + '" data-bloco="ia-' + esc(p.id) + '">' + fotoHtml(p) + '</a>' +
      '<div class="item-corpo"><h3 class="item-nome">' + esc(p.nome) + '</h3>' +
      (p.porque ? '<p class="item-porque">' + esc(p.porque) + '</p>' : '') +
      '<div class="item-base"><span class="item-precos">' + (p.de ? '<span class="de">' + fmt(p.de) + '</span>' : '') + '<span class="preco">' + fmt(p.preco) + '</span></span>' +
      '<button type="button" class="btn btn-cheio btn-add" data-add data-variante="' + esc(p.variante) + '" data-url="' + esc(href) + '" data-bloco="ia-' + esc(p.id) + '">Adicionar ao carrinho</button></div></div></article>';
  }

  function pintarResposta(d) {
    ia.classList.remove('ia-carregando');
    iaTitulo.textContent = d.titulo;
    iaIntro.textContent = d.intro;
    iaItens.innerHTML = d.itens.map(itemHtml).join('');
    iaCta.href = d.url;
    iaCta.querySelector('span').textContent = d.cta;
  }

  // Emoji da sugestão é só enfeite: não entra no termo buscado.
  var semEmoji = function (s) { return String(s || '').replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\uFE0F\u200D]/gu, '').replace(/\s+/g, ' ').trim(); };
  function buscar(q, filtro) {
    q = semEmoji(q);
    if (!q || !ia) return;
    busca = { q: q, f: filtro || '' };
    campo.value = q;
    corpo.dataset.view = 'busca';
    var botaoBarato = document.querySelector('[data-filtro="barato"]');
    if (botaoBarato) botaoBarato.setAttribute('aria-pressed', busca.f === 'barato' ? 'true' : 'false');

    ia.classList.add('ia-carregando');
    if (!iaItens.children.length) {
      iaTitulo.textContent = 'Procurando';
      iaIntro.textContent = 'Só um instante, estou separando pra você.';
      iaItens.innerHTML = '<div class="esqueleto"></div><div class="esqueleto"></div>';
      iaCta.querySelector('span').textContent = 'Ver no site';
    }

    var meu = ++pedido;
    responder(q, busca.f)
      .then(function (d) { if (meu === pedido) pintarResposta(d); })
      .catch(function () {
        if (meu !== pedido) return;
        pintarResposta({ titulo: 'Ops', intro: 'Não consegui buscar agora. Tenta de novo ou vê direto no site.', itens: [], url: destino({ busca: q }), cta: 'Buscar "' + q + '" no site' });
      });

    evento('busca', { termo: q, filtro: busca.f });
    try { history.replaceState(null, '', location.pathname + '?q=' + encodeURIComponent(q)); } catch (e) { /* sem histórico */ }
  }

  function limparBusca() {
    pedido++;
    busca = { q: '', f: '' };
    campo.value = '';
    iaItens.innerHTML = '';
    corpo.dataset.view = 'inicio';
    try { history.replaceState(null, '', location.pathname); } catch (e) { /* sem histórico */ }
    window.scrollTo(0, 0);
    campo.focus();
  }

  if (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      campo.blur();
      buscar(campo.value, '');
    });
  }

  // ===================== Quiz da consultora =====================
  var Q = B.quiz;
  var qz = { passo: 0, resp: {} };
  var quizCorpo = $('quiz-corpo');

  function perguntas() {
    var amb = Q.ambientes[qz.resp.amb] || Q.ambientes[Object.keys(Q.ambientes)[0]];
    return [
      {
        chave: 'amb', fala: 'Oi! Qual ambiente você quer organizar?', sub: 'Eu sou a consultora da Ela Decora. Toca numa opção e eu te guio.',
        opcoes: Object.keys(Q.ambientes).map(function (k) { var a = Q.ambientes[k]; return { id: k, nome: a.nome, icone: B.ic[a.cat], tint: tint(a.cat) }; })
      },
      {
        chave: 'inc', fala: 'Boa! E o que mais te incomoda hoje ' + amb.prep + '?', sub: 'Escolhe a que mais pesa no seu dia a dia.',
        opcoes: Object.keys(Q.incomodos).map(function (k) { var i = Q.incomodos[k]; return { id: k, nome: i.nome, icone: B.ic[i.icone], tint: '#FFFFFF' }; })
      },
      {
        chave: 'inv', fala: 'Última! Quanto você quer investir agora?', sub: 'Sem pressão: dá pra começar pequeno e ir completando.',
        opcoes: Object.keys(Q.investimentos).map(function (k) { var v = Q.investimentos[k]; return { id: k, nome: v.nome, dica: v.dica, icone: B.ic.tag, tint: '#FFFFFF' }; })
      }
    ];
  }

  function pintarProgresso() {
    var fim = qz.passo >= 3;
    var idx = Math.min(qz.passo, 2);
    $('quiz-label').textContent = fim ? 'Pronto!' : 'Pergunta ' + (idx + 1) + ' de 3';
    $('quiz-frac').textContent = fim ? '3/3' : (idx + 1) + '/3';
    var barras = $('quiz-barras');
    barras.setAttribute('aria-valuenow', fim ? 3 : idx + 1);
    Array.prototype.forEach.call(barras.children, function (b, i) { b.className = fim || i <= idx ? 'on' : ''; });
    $('quiz-voltar').disabled = qz.passo === 0;
  }

  function pintarPergunta() {
    var p = perguntas()[Math.min(qz.passo, 2)];
    quizCorpo.innerHTML = '<div class="quiz-pergunta"><div><h1>' + esc(p.fala) + '</h1><p class="quiz-sub">' + esc(p.sub) + '</p></div>' +
      '<div class="quiz-opcoes">' + p.opcoes.map(function (o) {
        return '<button type="button" class="quiz-opcao' + (qz.resp[p.chave] === o.id ? ' sel' : '') + '" data-opcao="' + esc(o.id) + '" data-chave="' + p.chave + '">' +
          '<span class="quiz-opcao-icone" style="background:' + o.tint + '">' + svg(o.icone, 24, 1.6) + '</span>' +
          '<span class="quiz-opcao-texto"><b>' + esc(o.nome) + '</b>' + (o.dica ? '<small>' + esc(o.dica) + '</small>' : '') + '</span>' +
          svg(B.ic.chev, 18, 2) + '</button>';
      }).join('') + '</div>' +
      '<a class="quiz-pessoa" href="' + esc(B.wpp) + '" target="_blank" rel="noopener" data-bloco="quiz-whatsapp">Prefiro falar com uma pessoa</a></div>';
  }

  function pintarResultado() {
    var ambK = Q.ambientes[qz.resp.amb] ? qz.resp.amb : Object.keys(Q.ambientes)[0];
    var incK = Q.incomodos[qz.resp.inc] ? qz.resp.inc : Object.keys(Q.incomodos)[0];
    var invK = Q.investimentos[qz.resp.inv] ? qz.resp.inv : 'mid';
    var amb = Q.ambientes[ambK], inc = Q.incomodos[incK], inv = Q.investimentos[invK];
    // Recomendação: lista (leva todos) ou { itens, max } (leva os primeiros `max` que têm estoque).
    var rec = (Q.recomendacoes[ambK] || {})[invK] || [];
    var recap = '<div class="quiz-recap"><span>' + esc(amb.nome) + '</span><span>' + esc(inc.nome) + '</span><span>' + esc(inv.nome) + '</span></div>';
    var refazer = '<button type="button" class="quiz-refazer" data-refazer>' + svg(B.ic.refresh, 16, 1.9) + ' Refazer o quiz</button>';
    var semEstoque = '<div class="quiz-resultado"><div><h1>Essa combinação esgotou agora.</h1><p class="quiz-msg">Chama a gente no WhatsApp que montamos outra ' + esc(amb.para) + '.</p></div>' + recap +
      '<a class="btn btn-zap" href="' + esc(B.wpp) + '" target="_blank" rel="noopener" data-bloco="quiz-whatsapp">' + svg(B.ic.chat, 22) + ' Falar no WhatsApp</a>' + refazer + '</div>';

    quizCorpo.innerHTML = '<div class="quiz-resultado"><div><h1>Achei! Isso aqui tem a sua cara.</h1></div>' + recap + '<div class="esqueleto"></div><div class="esqueleto"></div></div>';
    var passoAtual = qz;

    porIds(rec.itens || rec).then(function (lista) {
      if (passoAtual !== qz || qz.passo < 3) return;
      var itens = soDisponiveis(lista).slice(0, rec.max || 99);
      var n = itens.length;
      if (!n) { quizCorpo.innerHTML = semEstoque; return; }
      var total = itens.reduce(function (s, p) { return s + p.preco; }, 0);
      var intro = inc.semComida && inc.semComida.indexOf(ambK) >= 0 ? inc.introSemComida : inc.intro;
      var parc = Math.max(1, Math.min(B.pag.max, Math.floor(total / B.pag.min)));
      var comprar = '/cart/' + itens.map(function (p) { return p.variante + ':1'; }).join(',');
      evento('quiz_resultado', { ambiente: ambK, incomodo: incK, investimento: invK, itens: n });

      quizCorpo.innerHTML = '<div class="quiz-resultado"><div><h1>Achei! Isso aqui tem a sua cara.</h1>' +
        '<p class="quiz-msg">' + esc(intro + ' Separei ' + (n === 1 ? 'este' : 'estes') + ' ' + amb.para + ':') + '</p></div>' + recap +
        '<div class="quiz-itens">' + itens.map(function (p) {
          var href = urlProduto(p.handle);
          return '<article class="item"><a class="item-foto" href="' + esc(href) + '" aria-label="Ver produto: ' + esc(p.nome) + '" style="background:' + tint(p.cat) + '" data-bloco="quiz-' + esc(p.id) + '">' + fotoHtml(p) + '</a>' +
            '<div class="item-corpo"><h2 class="item-nome">' + esc(p.nome) + '</h2>' + (p.porque ? '<p class="item-porque">' + esc(p.porque) + '</p>' : '') +
            '<div class="item-base"><span class="preco">' + fmt(p.preco) + '</span><a class="quiz-ver" href="' + esc(href) + '" data-bloco="quiz-' + esc(p.id) + '">Ver produto</a></div></div></article>';
        }).join('') + '</div>' +
        '<div class="quiz-total"><div class="quiz-total-linha"><span>' + (n === 1 ? 'Levando este' : 'Levando os ' + n) + '</span><b>' + fmt(total) + '</b></div>' +
        '<div class="quiz-total-info"><span>' + (parc > 1 ? 'ou ' + parc + 'x de ' + fmt(total / parc) + ' sem juros' : '') + '</span>' +
        '<span class="pix">' + (B.pag.pix > 0 ? fmt(total * (1 - B.pag.pix / 100)) + ' no Pix' : '') + '</span></div>' +
        '<a class="btn btn-cheio" href="' + esc(comprar) + '" data-bloco="quiz-comprar-' + esc(ambK) + '-' + esc(invK) + '">' + svg(B.ic.bag, 18, 1.8) + ' ' + (n === 1 ? 'Colocar no carrinho' : 'Colocar os ' + n + ' no carrinho') + '</a></div>' +
        refazer + '</div>';
    }).catch(function () {
      if (passoAtual === qz) quizCorpo.innerHTML = semEstoque;
    });
  }

  function pintarQuiz() {
    pintarProgresso();
    if (qz.passo >= 3) pintarResultado(); else pintarPergunta();
    window.scrollTo(0, 0);
  }
  function abrirQuiz() {
    qz = { passo: 0, resp: {} };
    corpo.dataset.view = 'quiz';
    evento('quiz_abriu', {});
    pintarQuiz();
  }
  function fecharQuiz() {
    corpo.dataset.view = busca.q ? 'busca' : 'inicio';
    window.scrollTo(0, 0);
  }

  // ===================== Adicionar ao carrinho =====================
  // Adiciona sem sair da página; a sacola do topo mostra a quantidade e o botão vira "Ver carrinho".
  function atualizarSacola(qtd) {
    var sacola = document.querySelector('.topo-sacola');
    if (!sacola) return;
    var selo = sacola.querySelector('.topo-qtd');
    if (!selo && qtd > 0) { selo = document.createElement('span'); selo.className = 'topo-qtd'; sacola.appendChild(selo); }
    if (selo) { selo.textContent = qtd; selo.hidden = !(qtd > 0); }
    sacola.setAttribute('aria-label', 'Ver carrinho' + (qtd > 0 ? ' (' + qtd + ')' : ''));
  }
  function adicionar(botao, variante, urlProduto, bloco) {
    if (botao.dataset.estado === 'no-carrinho') { location.href = '/cart'; return; }
    if (botao.disabled) return;
    var texto = botao.textContent;
    botao.disabled = true;
    botao.textContent = 'Adicionando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('carrinho ' + r.status); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        atualizarSacola(carrinho.item_count);
        botao.disabled = false;
        botao.dataset.estado = 'no-carrinho';
        botao.textContent = 'Ver carrinho';
        evento('add_carrinho', { bloco: bloco, variante: String(variante) });
      })
      .catch(function () {
        // Não deu pra adicionar daqui (estoque, limite, rede): leva para a página do produto.
        botao.disabled = false;
        botao.textContent = texto;
        if (urlProduto) location.href = urlProduto;
      });
  }

  // ===================== Medição =====================
  // Cada clique em link com data-bloco vira um evento, para saber qual bloco da bio leva gente à loja.
  function evento(nome, dados) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'linkbio_' + nome }, dados));
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('linkbio_' + nome, dados);
    } catch (e) { /* medição nunca pode travar a página */ }
  }

  // ===================== Eventos =====================
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('a[data-bloco]');
    if (link) evento('clique', { bloco: link.dataset.bloco, destino: link.getAttribute('href') });

    var add = ev.target.closest('button[data-add]');
    if (add) return adicionar(add, add.dataset.variante, add.dataset.url, add.dataset.bloco);

    var alvo = ev.target.closest('[data-busca],[data-abrir-quiz],[data-limpar],[data-filtro],[data-opcao],[data-refazer],#quiz-fechar,#quiz-voltar');
    if (!alvo) return;
    if (alvo.dataset.busca) return buscar(alvo.dataset.busca, '');
    if ('abrirQuiz' in alvo.dataset) return abrirQuiz();
    if ('limpar' in alvo.dataset) return limparBusca();
    if (alvo.dataset.filtro) return buscar(busca.q, busca.f === alvo.dataset.filtro ? '' : alvo.dataset.filtro);
    if (alvo.dataset.opcao) {
      qz = { passo: Math.min(qz.passo, 2) + 1, resp: Object.assign({}, qz.resp) };
      qz.resp[alvo.dataset.chave] = alvo.dataset.opcao;
      return pintarQuiz();
    }
    if ('refazer' in alvo.dataset) { qz = { passo: 0, resp: {} }; return pintarQuiz(); }
    if (alvo.id === 'quiz-fechar') return fecharQuiz();
    if (alvo.id === 'quiz-voltar') { qz = { passo: Math.max(0, Math.min(qz.passo, 3) - 1), resp: qz.resp }; return pintarQuiz(); }
  });

  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest('form[data-add]');
    if (!f) return;
    ev.preventDefault();
    adicionar(f.querySelector('button'), f.querySelector('[name="id"]').value, f.dataset.url, f.dataset.bloco);
  });

  // Links diretos (bons para stories): ?q=organizar+a+geladeira abre na busca; #quiz abre o quiz.
  var inicial = new URLSearchParams(location.search).get('q');
  if (inicial) buscar(inicial, '');
  else if (location.hash === '#quiz') abrirQuiz();
})();
